import { AccountBox, PowerSettingsNew } from "@mui/icons-material";
import { IconButton, ListItemIcon, ListItemText, MenuItem, MenuList, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { userSignout } from "@nerdjs/account-kit";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../hooks";
import { StyledMenu } from "../nerdAppBar/nerdAppBar";
import { Button } from "@mui/joy";

/**
 * @component
 * @returns {React.ReactElement} UserDisplay component
 */
export function NerdUserMenu(): React.ReactElement {
  const [anchorEl, setAnchorEl] = React.useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const { t } = useTranslation();
  const open = Boolean(anchorEl);
  const id = open ? "basic-menu" : undefined;
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  /**
   * Disconnect user
   */
  function signout() {
    dispatch(userSignout());
  }

  return (
    <>
      {md ? (
        <Button
          size="sm"
          onClick={handleClick}
          variant={"outlined"}
          startIcon={<AccountBox fontSize="small" />}
        >
          {t("global.my_account")}
        </Button>
      ) : (
        <Tooltip title={t("entities:app.entity")}>
          <IconButton color="primary" size="small" onClick={handleClick}>
            <AccountBox />
          </IconButton>
        </Tooltip>
      )}
      <StyledMenu
        id={id}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
      >
        <MenuList>
          <MenuItem onClick={signout}>
            <ListItemIcon>
              <PowerSettingsNew />
            </ListItemIcon>
            <ListItemText>{t("global.signout")}</ListItemText>
          </MenuItem>
        </MenuList>
      </StyledMenu>
    </>
  );
}
